import React from "react";

const useScrollShadows = (
  contentRef: React.RefObject<HTMLDivElement>,
  wrapperRef: React.RefObject<HTMLDivElement>,
  shadowTopRef: React.RefObject<HTMLDivElement>,
  shadowBottomRef: React.RefObject<HTMLDivElement>,
  key: any
) => {
  const applyScrollShadows = () => {
    const contentScrollHeight = (contentRef.current?.scrollHeight ?? 0) - (wrapperRef.current?.offsetHeight ?? 0);
    const scrollProgress = ((contentRef.current?.scrollTop ?? 0) + contentScrollHeight) / contentScrollHeight;

    const scrollTopOpacity = scrollProgress > 0.1 ? 1 : scrollProgress * 10;
    const scrollBottomOpacity = scrollProgress < 0.9 ? 1 : (1 - scrollProgress) * 10;

    shadowTopRef.current!.style.opacity = scrollTopOpacity.toString();
    shadowBottomRef.current!.style.opacity = scrollBottomOpacity.toString();
  };

  React.useEffect(() => {
    if (contentRef.current && wrapperRef.current && shadowTopRef.current && shadowBottomRef.current) {
      contentRef.current.addEventListener("scroll", applyScrollShadows);

      setTimeout(() => {
        const shadowVisible = (contentRef.current?.scrollHeight ?? 0) > (contentRef.current?.clientHeight ?? 0);
        if (shadowVisible) {
          applyScrollShadows();
        }
      }, 100); //TODO find better triggers than time
    }

    return () => {
      contentRef.current && contentRef.current.removeEventListener("scroll", applyScrollShadows);
    };
  }, [contentRef, wrapperRef, shadowTopRef, shadowBottomRef, key]);
};

export default useScrollShadows;
